// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js!../../input/style/index.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../../../node_modules/css-loader/dist/cjs.js!../../common_style/arrow_button.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =============================================================================
    overwrite base input style
   ===========================================================================*/
.swiftref-input swiftref-icon {
    position: absolute;
    top: calc(var(--spacing-15) + 1px);
    right: var(--spacing-10);
    left: unset;
    width: fit-content;
}
.swiftref-input .clear-icon {
    right: var(--spacing-30);
}
/*:host(:not([message]) .swiftref-input swiftref-message {*/
/*    margin-top: 0;*/
/*    display: none;*/
/*}*/


/* =============================================================================
    date_input style
   ===========================================================================*/

:host {
    display: block;
    position: relative;
}

.datepicker-container {
    position: relative;
}


.datepicker-calendar {
    position: absolute;
    top: 80px;
    left: 0;
    z-index: 10;
    background: var(--background-default);
    border: 1px solid var(--border-light);
    border-radius: 4px;
    box-shadow: var(--shadow-light);
    width: 300px;
    display: none;
    margin-top: var(--spacing-05);
}
:host(:not([message])) .datepicker-calendar {
  top: 64px;
}
:host(:not([message])[kind="compact"]) .datepicker-calendar {
    top: 40px;
}

.datepicker-calendar.open {
    display: block;
}

.datepicker-calendar.inline {
    position: static;
    display: block;
    margin-top: 10px;
    box-shadow: none;
}

.calendar-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: var(--spacing-05);
    border-bottom: 1px solid var(--border-light);
    border-radius: 4px 4px 0 0;
}
.calendar-header > div {
    display: flex;
}
.month-year {
    margin: 0;
}


.calendar-body {
    padding: var(--spacing-05);
}

.weekdays {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    text-align: center;
    font-weight: bold;
    margin-bottom: 5px;
}

.weekdays span {
    padding: 5px;
    font-size: 14px;
    color: var(--text-default);
}

.days-grid {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 2px;
}

.day {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 36px;
    font-size: 14px;
    border-radius: 4px;
    cursor: default;
}

.day.hover:not(.disabled):not(.other-month),
.day:hover:not(.disabled):not(.other-month) {
    background: var(--accent-light-hover);
    cursor: pointer;
    outline: none;
}

.day.selected {
    background: var(--accent-light-default);
}

.day.today:not(.selected) {
    border: 1px solid var(--border-strong);
}

.day.disabled {
    color: var(--text-placeholder);
    cursor: not-allowed;
}

.day.other-month {
    color: var(--text-placeholder);
}

.day.in-range {
    background-color: var(--accent-light-selected);
}
.time-container {
    text-align: center;
    margin-bottom: 8px;
}
.calendar-footer {
    padding: 8px;
    border-top: 1px solid var(--border-light);
    display: flex;
    justify-content: space-between;
}


input:empty::placeholder {
    font-size: 11px;
}
`, "",{"version":3,"sources":["webpack://./../website_design_system/src/components/form/date/style/index.css"],"names":[],"mappings":"AAGA;;+EAE+E;AAC/E;IACI,kBAAkB;IAClB,kCAAkC;IAClC,wBAAwB;IACxB,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,wBAAwB;AAC5B;AACA,2DAA2D;AAC3D,qBAAqB;AACrB,qBAAqB;AACrB,IAAI;;;AAGJ;;+EAE+E;;AAE/E;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;;AAGA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,qCAAqC;IACrC,qCAAqC;IACrC,kBAAkB;IAClB,+BAA+B;IAC/B,YAAY;IACZ,aAAa;IACb,6BAA6B;AACjC;AACA;EACE,SAAS;AACX;AACA;IACI,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,0BAA0B;IAC1B,4CAA4C;IAC5C,0BAA0B;AAC9B;AACA;IACI,aAAa;AACjB;AACA;IACI,SAAS;AACb;;;AAGA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,eAAe;AACnB;;AAEA;;IAEI,qCAAqC;IACrC,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8CAA8C;AAClD;AACA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,yCAAyC;IACzC,aAAa;IACb,8BAA8B;AAClC;;;AAGA;IACI,eAAe;AACnB","sourcesContent":["@import '../../input/style/index.css';\n@import '../../common_style/arrow_button.css';\n\n/* =============================================================================\n    overwrite base input style\n   ===========================================================================*/\n.swiftref-input swiftref-icon {\n    position: absolute;\n    top: calc(var(--spacing-15) + 1px);\n    right: var(--spacing-10);\n    left: unset;\n    width: fit-content;\n}\n.swiftref-input .clear-icon {\n    right: var(--spacing-30);\n}\n/*:host(:not([message]) .swiftref-input swiftref-message {*/\n/*    margin-top: 0;*/\n/*    display: none;*/\n/*}*/\n\n\n/* =============================================================================\n    date_input style\n   ===========================================================================*/\n\n:host {\n    display: block;\n    position: relative;\n}\n\n.datepicker-container {\n    position: relative;\n}\n\n\n.datepicker-calendar {\n    position: absolute;\n    top: 80px;\n    left: 0;\n    z-index: 10;\n    background: var(--background-default);\n    border: 1px solid var(--border-light);\n    border-radius: 4px;\n    box-shadow: var(--shadow-light);\n    width: 300px;\n    display: none;\n    margin-top: var(--spacing-05);\n}\n:host(:not([message])) .datepicker-calendar {\n  top: 64px;\n}\n:host(:not([message])[kind=\"compact\"]) .datepicker-calendar {\n    top: 40px;\n}\n\n.datepicker-calendar.open {\n    display: block;\n}\n\n.datepicker-calendar.inline {\n    position: static;\n    display: block;\n    margin-top: 10px;\n    box-shadow: none;\n}\n\n.calendar-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: var(--spacing-05);\n    border-bottom: 1px solid var(--border-light);\n    border-radius: 4px 4px 0 0;\n}\n.calendar-header > div {\n    display: flex;\n}\n.month-year {\n    margin: 0;\n}\n\n\n.calendar-body {\n    padding: var(--spacing-05);\n}\n\n.weekdays {\n    display: grid;\n    grid-template-columns: repeat(7, 1fr);\n    text-align: center;\n    font-weight: bold;\n    margin-bottom: 5px;\n}\n\n.weekdays span {\n    padding: 5px;\n    font-size: 14px;\n    color: var(--text-default);\n}\n\n.days-grid {\n    display: grid;\n    grid-template-columns: repeat(7, 1fr);\n    gap: 2px;\n}\n\n.day {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 36px;\n    font-size: 14px;\n    border-radius: 4px;\n    cursor: default;\n}\n\n.day.hover:not(.disabled):not(.other-month),\n.day:hover:not(.disabled):not(.other-month) {\n    background: var(--accent-light-hover);\n    cursor: pointer;\n    outline: none;\n}\n\n.day.selected {\n    background: var(--accent-light-default);\n}\n\n.day.today:not(.selected) {\n    border: 1px solid var(--border-strong);\n}\n\n.day.disabled {\n    color: var(--text-placeholder);\n    cursor: not-allowed;\n}\n\n.day.other-month {\n    color: var(--text-placeholder);\n}\n\n.day.in-range {\n    background-color: var(--accent-light-selected);\n}\n.time-container {\n    text-align: center;\n    margin-bottom: 8px;\n}\n.calendar-footer {\n    padding: 8px;\n    border-top: 1px solid var(--border-light);\n    display: flex;\n    justify-content: space-between;\n}\n\n\ninput:empty::placeholder {\n    font-size: 11px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
